// src/components/Logo.js
import React from 'react';
import { Link } from 'react-router-dom';

function Logo({ className = "" }) {
  const logoUrl = "https://cdn.shopify.com/s/files/1/0642/2799/9902/files/wakaLogoFold.png?v=1743359305";
  
  return (
    <Link to="/">
      <img 
        src={logoUrl} 
        alt="Waka Folding Technology Logo" 
        style={{ 
          width: '100%', 
          maxWidth: '280px', 
          height: 'auto', 
          cursor: 'pointer',
          margin: '0 auto',
          display: 'block'
        }} 
        className={className}
      />
    </Link>
  );
}

export default Logo;